import { Search } from 'lucide-react';
import { useState } from 'react';
import Accordion from '../components/Accordion';

const faqItems = [
  {
    id: '1',
    category: 'Регистрация и участие',
    question: 'Кто может участвовать в чемпионате?',
    answer: 'К участию приглашаются школьники 8–11 классов и студенты 1–2 курсов СПО в возрасте от 14 до 18 лет на момент старта чемпионата. Участие бесплатное.',
  },
  {
    id: '2',
    category: 'Регистрация и участие',
    question: 'Можно ли участвовать в нескольких направлениях?',
    answer: 'Нет, каждый участник может выбрать только одно направление (Геймдев, 3D-моделирование или геймдизайн). Это связано с форматом проведения и нагрузкой на участников.',
  },
  {
    id: '3',
    category: 'Регистрация и участие',
    question: 'Как проходит регистрация?',
    answer: 'Регистрация проходит онлайн на этом сайте. Нужно заполнить форму, указать личные данные, выбрать направление и при желании загрузить портфолио.',
  },
  {
    id: '4',
    category: 'Регистрация и участие',
    question: 'До какого числа открыта регистрация?',
    answer: 'Регистрация открыта до 30 октября 2026 года 23:59 по московскому времени. Рекомендуем не откладывать подачу заявки на последний день.',
  },
  {
    id: '5',
    category: 'Технические требования',
    question: 'Какое программное обеспечение понадобится?',
    answer: 'В зависимости от направления: Unity и Visual Studio (игровая разработка), Blender (3D-моделирование), Figma или Miro (геймдизайн). Полный список будет отправлен участникам после регистрации.',
  },
  {
    id: '6',
    category: 'Технические требования',
    question: 'Нужен ли мощный компьютер?',
    answer: 'Для 3D-моделирования и разработки игр желателен компьютер с дискретной видеокартой и 8+ ГБ оперативной памяти. Для геймдизайна подойдёт и средний ноутбук.',
  },
  {
    id: '7',
    category: 'Технические требования',
    question: 'Можно ли использовать готовые ассеты из магазинов?',
    answer: 'Да, но с ограничениями. Основная оценка идёт за оригинальность и творческий подход. Использование готовых ассетов должно быть обосновано и указано в описании проекта.',
  },
  {
    id: '8',
    category: 'Организационные вопросы',
    question: 'Будут ли мастер-классы и помощь менторов?',
    answer: 'Да, на этапе командообразования и финала участники получат доступ к мастер-классам от экспертов индустрии и персональным консультациям менторов.',
  },
  {
    id: '9',
    category: 'Организационные вопросы',
    question: 'Как формируются команды?',
    answer: 'После индивидуального отбора участники объединяются в команды по 3–5 человек. Учитываются пожелания участников и баланс навыков.',
  },
  {
    id: '10',
    category: 'Организационные вопросы',
    question: 'Где будет проходить финал?',
    answer: 'Финальный этап пройдёт в очно-заочном формате. Очная часть состоится в Ханты-Мансийске.',
  },
  {
    id: '11',
    category: 'Призы и награды',
    question: 'Какие призы можно выиграть?',
    answer: 'Победители (1-е место) получают ценные призы и дипломы I степени, призёры (2-е и 3-е места) — ценные призы и дипломы II или III степени. Дипломы вручаются каждому члену команды в электронной и/или печатной форме. Финалисты, не занявшие призовых мест, получают диплом финалиста Чемпионата, а также, при наличии, поощрительные призы от партнёров',
  },
  {
    id: '12',
    category: 'Призы и награды',
    question: 'Можно ли получить сертификат участника?',
    answer: 'Участники, успешно прошедшие I этап, но не допущенные ко II этапу, получают сертификат участника Чемпионата.',
  },
  {
    id: '13',
    category: 'Прочее',
    question: 'Как связаться с организаторами?',
    answer: 'Вы можете написать на почту info@o4ki.online, позвонить по телефону +7 (909) 71-22-777 или присоединиться к Max-чату поддержки (ссылка внизу страницы).',
  },
  {
    id: '14',
    category: 'Прочее',
    question: 'Где можно ознакомиться с положением чемпионата?',
    answer: 'Положение доступно для скачивания в формате PDF на странице «О чемпионате» и в разделе «Регистрация». Рекомендуем внимательно его изучить перед подачей заявки.',
  },
];

export default function FaqPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState<string>('all');

  const categories = ['all', ...Array.from(new Set(faqItems.map(item => item.category)))];

  const filteredItems = faqItems.filter(item => {
    const matchesSearch = item.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         item.answer.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || item.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900">Часто задаваемые вопросы</h1>
        <p className="mt-4 text-xl text-gray-600">
          Не нашли ответ? Напишите нам в Max-чат поддержки.
        </p>
      </div>

      <div className="mb-10">
        <div className="relative max-w-2xl mx-auto">
          <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
          <input
            type="text"
            placeholder="Поиск по вопросам..."
            className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <div className="flex flex-wrap justify-center gap-4 mt-6">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setSelectedCategory(cat)}
              className={`px-5 py-2 rounded-full font-medium ${
                selectedCategory === cat
                  ? 'bg-primary-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {cat === 'all' ? 'Все категории' : cat}
            </button>
          ))}
        </div>
      </div>

      <div className="mb-12">
        {filteredItems.length > 0 ? (
          <Accordion items={filteredItems} groupedByCategory={selectedCategory === 'all'} />
        ) : (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">По вашему запросу ничего не найдено.</p>
            <p className="text-gray-400">Попробуйте изменить поисковый запрос или выбрать другую категорию.</p>
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="card text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">MAX-чат поддержки</h3>
          <p className="text-gray-600 mb-6">
            Задайте вопрос напрямую организаторам и получите ответ в течение дня.
          </p>
          <a
            href="https://max.ru/join/jgM0K2Z4bv69V0W2y-mFAHJa5CfTIOlmkiyvsCvNgRY"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary inline-flex items-center justify-center w-full"
          >
            Перейти в чат
          </a>
        </div>
        <div className="card text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Положение чемпионата</h3>
          <p className="text-gray-600 mb-6">
            Ознакомьтесь с полными правилами, критериями оценки и регламентом.
          </p>
          <a
            href="/documents/regulation/polozhenie_2026-2027.pdf"
            className="btn-secondary inline-flex items-center justify-center w-full"
          >
            Скачать PDF
          </a>
        </div>
        <div className="card text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Контакты организаторов</h3>
          <p className="text-gray-600 mb-6">
            Email: info@o4ki.online<br />
            Телефон: +7 (909) 71-22-777
          </p>
          <a
            href="/contacts"
            className="btn-secondary inline-flex items-center justify-center w-full"
          >
            Страница контактов
          </a>
        </div>
      </div>
    </div>
  );
}